import { render, staticRenderFns } from "./aSegmentationReportRnChart.vue?vue&type=template&id=45b68440"
import script from "./aSegmentationReportRnChart.vue?vue&type=script&lang=js"
export * from "./aSegmentationReportRnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports